<template>
  <div id="app">
    <div class="container">
      <header>
        <div class="logo_view">
          <img src="../assets/logo.png" alt="logo" @click="toHome" style="width: 41px;height: 41px">
          <img src="../assets/logo1.png" alt="logo" @click="toHome" style="width: 144px;height: 22px">
          <span>Fulfillment</span>
        </div>
        <a-tabs :default-active-key="activeKey"
                v-model="activeKey"
                @change="callback"
                :tabBarStyle="{ borderBottom: 'unset' }">
          <a-tab-pane
            v-for="item in types"
            :key="item.key"
            :tab="item.name">
          </a-tab-pane>
        </a-tabs>
        <div class="login_btn">
          <img src="../assets/login.png" style="width: 30px;height: 30px"/>
          <span @click="goLogin()">Login</span>
        </div>
      </header>
      <main>
        <div class="tracking">
          <div class="tracking_view" @scroll="handleScroll($event)">
            <a-table
              class="table"
              :defaultExpandedRowKeys="[0]"
              :expandIconAsCell="false"
              :loading="loading"
              :expandIconColumnIndex="-1"
              :row-key="(record) => record.trackNumber"
              :columns="columns"
              :customRow="rowClick"
              @expand="onExpand"
              :rowClassName="rowClassName"
              :expandedRowKeys="expandedRowKeys"
              expandRowByClick
              :data-source="nowList"
              :pagination="false">
              <span slot="trackNumber" slot-scope="text, record">
                <span>{{ record.trackNumber }}&nbsp;
                  <a-icon type="copy" v-show="record.isShow" @click.stop="tCopyContent(record.trackNumber)"/>
                </span>
              </span>
              <span slot="toCountryCode" slot-scope="text, record">
                CN → {{ record.toCountryCode }}
              </span>
              <span slot="status" slot-scope="text, record">
               <a-tag :color="record.status | statusFilter(0)">
                  {{ record.status |statusFilter(1) }}
               </a-tag>
              </span>
              <span slot="service" slot-scope="text, record">
                 Printbelle Registered Standard General
              </span>
              <span slot="agentWaybillNo" slot-scope="text, record">
                 <div>{{ record.agentWaybillNo || 'N/A' }}&nbsp;
                    <a-icon type="copy" v-show="record.isShow&&record.agentWaybillNo"
                            @click.stop="tCopyContent(record.agentWaybillNo)"/>
                  </div>
              </span>
              <span slot="LastEvent" slot-scope="text, record" class="record_item">
                <a-tooltip placement="bottom">
                  <template slot="title">
                    <span>{{
                        record.trackInfo ? record.trackInfo[0].checkpointDate + '' + record.trackInfo[0].trackingDetail : ''
                      }}</span>
                  </template>
                  {{
                    record.trackInfo ? record.trackInfo[0].checkpointDate + '' + record.trackInfo[0].trackingDetail : ''
                  }}
                </a-tooltip>
              </span>
              <div slot="expandedRowRender" slot-scope="record" style="margin: 0">
                <div class="row_title">
                  <a-icon type="copy"/>
                  <a href="javascript:" @click="tCopyContent(getDetails([record]))">Copy Details</a>
                  <a-icon type="copy" style="margin-left: 40px"/>
                  <a href="javascript:" @click="tCopyContent(getLink(record))">Copy Link</a>
                </div>
                <div class="roe_list">
                  <div class="list_l">
                    <div class="item" v-for="(item,index) in record.trackInfo">
                      <div class="item_view">
                        <span class="week">{{ weekDay(item.checkpointDate, 0) }}</span>
                        <span class="date">{{ weekDay(item.checkpointDate, 1) }}</span>
                        <span class="week">{{ weekDay(item.checkpointDate, 2) }}</span>
                      </div>
                      <div class="item_line">
                        <img src="../assets/aircraft.png" style="width: 20px;height: 21px" v-if="index===0"/>
                        <img src="../assets/cloud.png" style="width: 16px;height: 12px" v-else/>
                        <a-divider class="divider" type="vertical" dashed
                                   v-if="index !== (record.trackInfo.length-1) "/>
                      </div>
                      <span class="des">{{ item.trackingDetail }}</span>
                    </div>
                  </div>
                  <div class="list_r">
                    <div class="info_box">
                      Shipment Information
                    </div>
                    <div class="info_view">
                      Order Number
                      <span>{{ record.orderNo }}</span>
                      Country
                      <span>CN → {{ record.toCountryCode }}</span>
                    </div>
                    <div class="info_box">
                      Additional Notes
                    </div>
                    <div class="info_view">
                      <span>Distributor:USPS Distributor</span>
                      <span>Website:http://www.usps.com</span>
                      <span>Contact Number:1-800-275-8777</span>
                    </div>
                  </div>
                </div>

              </div>
            </a-table>
          </div>
        </div>
      </main>

    </div>
  </div>
</template>

<script>
import {tCopyContent} from '../utils/utils'

export default {
  name: 'Details',
  data () {
    return {
      loading: false,
      isShow: false,
      scroll: 0,
      activeKey: 2,
      selectIndex: 0,
      isExpand: true,
      expandedRowKeys: [],
      nowList: [],
      columns: [
        {
          title: 'Tracking Number',
          dataIndex: 'trackNumber',
          align: 'center',
          scopedSlots: {customRender: 'trackNumber'},
        },
        {
          title: 'Last Mile Tracking',
          dataIndex: 'agentWaybillNo',
          align: 'center',
          scopedSlots: {customRender: 'agentWaybillNo'},
        },
        {
          title: 'Origin→Destination',
          dataIndex: 'toCountryCode',
          align: 'center',
          scopedSlots: {customRender: 'toCountryCode'},
        },

        {
          title: 'Service',
          dataIndex: 'service',
          align: 'center',
          scopedSlots: {customRender: 'service'},
        },
        {
          title: 'Delivery Status',
          dataIndex: 'status',
          align: 'center',
          width: '150px',
          scopedSlots: {customRender: 'status'},
        },
        {
          title: 'Calendar Day (0 d)',
          dataIndex: 'Calendar',
          width: '120px',
          align: 'center',
        },
        {
          title: 'Working Day (0 d)',
          dataIndex: 'Working',
          width: '120px',
          align: 'center',
        },
      ],
      types: [
        {
          key: 0,
          name: 'Home',
        },
        {
          key: 1,
          name: 'Parcel Tracking',
        }
      ],
    }
  },
  filters: {
    statusFilter (status, type) {
      switch (status) {
        case 'pending':
        case 'InfoReceived':
          return type === 0 ? 'blue' : 'Processing'
        case 'transit':
        case 'pickup':
          return type === 0 ? 'orange' : 'Transit'
        case 'delivered':
          return type === 0 ? 'lime' : 'Delivered'
        case 'notfound':
          return type === 0 ? 'purple' : 'Not Found'
        case 'undelivered':
        case 'expired':
          return type === 0 ? 'geekblue' : 'Alert'
        case 'exception':
          return type === 0 ? 'red' : 'Exception'
      }
    },
  },
  mounted () {
    document.body.style.overflowY = 'hidden'
  },
  created () {
    let id = this.$route.query.id
    if (id) {
      this.getInfo(id)
    }
  },
  methods: {
    tCopyContent,
    async getInfo (val) {
      const map = new Map()
      let values = val.split(',')
      let value = values.filter(key => !map.has(key) && map.set(key, 1)).join(',')
      const {...params} = {id: value}
      this.loading = true
      this.$http({method: 'get', url: '/api/tracking/v1', params: params}).then((res) => {
        this.loading = false
        if (res.data.code === 200) {
          const resList = res.data.data
          resList.forEach(item => {
            item['isShow'] = false
            this.expandedRowKeys.push(item.trackNumber)
          })
          this.nowList = resList
        } else {
          this.$message.error(res.data.msg)
        }

      })
    },
    handleScroll (event) {
      let el = event.target
      this.scroll = el.scrollTop
    },
    callback (key) {
      if (key === 0) {
        this.$router.push({name: 'Index'})
      } else {
        this.$router.push({name: 'ParcelTracking'})
      }

    },
    rowClassName (record, index) {
      return index === this.selectIndex && this.isExpand ? 'active' : ''
    },
    rowClick (record, index) {
      return {
        on: {
          mouseenter: () => {//鼠标移入行
            record.isShow = false
          },
          mouseleave: () => {//鼠标移出行
            record.isShow = false
          },
          click: () => {
            this.selectIndex = index
          }
        }
      }
    },
    onExpand (expanded, record) {
      this.isExpand = expanded
      // 只展开一行
      if (this.expandedRowKeys.length > 0) { //进这个判断说明当前已经有展开的了
        //返回某个指定的字符串值在字符串中首次出现的位置，下标为0
        let index = this.expandedRowKeys.indexOf(record.trackNumber)
        if (index > -1) { //如果出现则截取这个id,1d到1相当于0，针对重复点击一个
          this.expandedRowKeys.splice(index, 1)
        } else {
          //如果没出现则截取所有id,添加点击id，0到1，针对已经有一个展开，点另一个会进入判断
          this.expandedRowKeys.splice(0, this.expandedRowKeys.length)
          this.expandedRowKeys.push(record.trackNumber)
        }
      } else {
        //数组长度小于0，说明都没展开，第一次点击，id添加到数组，数组有谁的id谁就展开
        this.expandedRowKeys.push(record.trackNumber)
      }
    },
    weekDay (val, type) {
      let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      let month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      let today = new Date(val)
      if (type === 0) {
        return days[today.getDay()]
      } else if (type === 1) {
        return month[today.getMonth() + 1] + ',' + today.getDate() + ',' + today.getFullYear()
      } else if (type === 2) {
        return val.slice(-8) + ' Local time'
      }
    },
    getLink (record) {
      let link = process.env.NODE_ENV === 'production' ? 'http://logistic.printbelle.com' : `http://${require('ip').address()}:${8080}`
      return `${link}/Track/Detailing?id=${record.trackNumber}`
    },
    toHome () {
      this.$router.push({name: 'AboutUs'})
    },
    goLogin () {
      window.open('https://www.printbelle.com/', '_blank')
    },
    getDetails (objList) {
      let person = ''
      objList.forEach((item, index) => {
        item['\n\nDivide'] = '====================================================' + '\n\n'
        Object.keys(item).map((key) => {
          if (key === 'trackInfo') {
            Object.keys(key).map((onKey) => {
              person += onKey + ':' + item.trackInfo[onKey].checkpointDate + '&nbsp;' + item.trackInfo[onKey].trackingDetail + '\n'
            })
          } else {
            if (key === 'isShow') return
            person += key + ':' + item[key] + '\n' // 获取到属性对应的值，做一些处理
          }

        })
      })
      return person
    }
  },

  beforeDestroy () {
    document.body.style.overflowY = 'visible'
  },
}
</script>


<style lang="less">

.active td {
  background: #761FEB !important;
  color: #FFFFFF;
}

.container {
  width: 100%;
  height: 100%;

  header {
    display: flex;
    align-items: center;
    position: fixed;
    width: 100%;
    min-width: 1900px;
    top: 0;
    left: 0;
    justify-content: space-between;
    height: 70px;
    width: 100%;
    padding: 0 47px;
    background-color: #152235;

    .logo_view {
      width: 395px;
      display: flex;
      height: 70px;
      align-items: center;

      img {
        margin-right: 18px;
      }

      span {
        font-size: 17px;
        font-family: OPPOSans;
        font-weight: bold;
        color: #C9C8C8;
        margin-left: 50px;
      }
    }

    .login_btn {
      width: 395px;
      display: flex;
      cursor: pointer;
      align-items: center;
      justify-content: right;
      height: 70px;

      span {
        height: 20px;
        font-size: 18px;
        line-height: 20px;
        font-weight: bold;
        margin-left: 10px;
        color: #C9C8C8;
      }
    }

    .ant-tabs-ink-bar {
      background-color: transparent;
    }

    .ant-tabs-bar {
      margin: 0;
    }

    .ant-tabs-tab {
      color: #FFFFFF;
      font-size: 18px;
      font-weight: bold;
    }

    .ant-tabs-tab-active {
      color: #FFB400;
    }

    .ant-tabs-tab:hover {
      color: #FFB400;
    }
  }

  main {

    .tracking {
      width: 100%;
      height: 100vh;
      overflow-y: hidden;
      font-family: Arial, Helvetica, sans-serif;

      .tracking_view {
        overflow-y: auto;
        height: 100%;
        margin-top: 70px;

        .table {
          width: 1200px;
          margin: 0 auto;
          padding-bottom: 80px;

          .ant-table-thead {
            background: #ECE3F8;
          }

          .ant-table-thead > tr > th {
            background: #ECE3F8;
            color: #606060;
          }

          .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
            background: #761FEB;
            color: #FFFFFF;
          }

          .ant-table-row-expand-icon {
            color: #606060;
          }

          .record_item {
            display: block;
            width: 100%;
            overflow: hidden;
            cursor: pointer;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }

          .row_title {
            font-size: 14px;
            font-family: OPPOSans;
            font-weight: 500;
            margin-bottom: 10px;
            text-decoration: underline;
            color: #010101;

            a {
              color: #010101;
              text-decoration: underline;
            }

          }

          .roe_list {
            display: flex;


            .list_l {
              width: 850px;

              .item:last-child {
                border-bottom: 1px solid transparent;
                padding-top: 16px;
                height: 82px;
              }

              .item {
                display: flex;
                align-items: center;
                height: 100px;
                border-bottom: 1px solid #E5E5E5;

                .item_view {
                  width: 170px;
                  display: flex;
                  flex-direction: column;

                  .week {
                    font-size: 15px;
                    font-family: OPPOSans;
                    font-weight: 400;
                    color: #000000;
                  }

                  .date {
                    font-size: 16px;
                    font-family: OPPOSans;
                    line-height: 28px;
                    font-weight: bold;
                    color: #000000;
                  }
                }

                .item_line {
                  margin: 0 70px;
                  position: relative;

                  .ant-divider {
                    height: 80px;
                    border-width: 0 0 0 2px;
                    color: #C9C9C9;
                    position: absolute;
                    left: -1px;
                    top: 20px;
                  }

                }

                .des {
                  flex: 1;
                  display: block;
                  font-size: 13px;
                  font-family: OPPOSans;
                  font-weight: 400;
                  color: #000000;
                  margin-right: 70px;
                  overflow: hidden;
                  -webkit-line-clamp: 2;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                }
              }
            }

            .list_r {
              flex: auto;
              display: flex;
              flex-direction: column;
              align-items: center;
              margin-left: 5px;
              padding-top: 116px;
              border-left: 1px solid #E5E5E5;

              .info_box {
                width: 268px;
                height: 43px;
                line-height: 43px;
                margin-top: 10px;
                margin-left: 16px;
                background: #F1E8FD;
                text-align: center;
                border-radius: 10px;
                font-size: 16px;
                font-family: OPPOSans;
                font-weight: 800;
                color: #761FEB;
              }

              .info_view {
                width: 226px;
                display: flex;
                flex-direction: column;
                margin: 16px 0;
                font-size: 14px;
                font-family: OPPOSans;
                font-weight: bold;
                color: #000000;
                line-height: 34px;

                span {
                  font-size: 14px;
                  font-weight: 400;
                  line-height: 24px;
                }
              }
            }
          }
        }
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/Details.vue